export default "__VITE_ASSET__aXREL_WC__"